<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('value')"
          :inputData.sync="entry.value"
          mask-type="currency"
          label="Valor"
          prefix="R$"
          persistent-hint
          @update:inputData="createInstallments"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.paymentMethodId"
          v-bind="getObject('paymentMethodId')"
          :label="'Forma de ' + typeText "
          :items="extraData.globalContext.allGlobalPaymentMethods"
          item-value="id"
          item-text="name"
          @input="selectPaymentMethod(null)"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="8">
        <!-- <v-autocomplete
          :disabled="entry.paymentMethodId ? false : true"
          v-model="entry.bankAccountId"
          v-bind="getObject('bankAccountId')"
          label="Conta Bancária"
          :items="bankAccountList"
          item-value="id"
          item-text="name"
          @input="selectBankAccount"
          :loading="bankAccountListLoading"
        /> -->
        <v-autocomplete
          :disabled="entry.paymentMethodId ? readOnly : true"
          v-model="entry.bankAccountId"
          v-bind="getObject('bankAccountId')"
          label="Conta Bancária"
          :items="bankAccountList"
          item-value="id"
          item-text="nameWithBank"
          @input="selectBankAccount"
          
          persistent-hint
          :loading="bankAccountListLoading"
          autocomplete="off"
        >

        <!-- :hint="entry.bankAccountId && entry.bankAccount ? ('Saldo Atual: ' + numberToCurrency(entry.bankAccount.currentBalance) + ', Tipo: ' + (entry.bankAccount.bankAccountType ? entry.bankAccount.bankAccountType.name : '') + (entry.bankAccount.agencyNumber ? ' - Agência: ' + entry.bankAccount.agencyNumber : '') + (entry.bankAccount.agencyNumber ? ' - Número: ' + entry.bankAccount.accountNumber : '')) : '' " -->
        <!-- <v-list-item-subtitle>
                Saldo Atual: <strong>{{numberToCurrency(data.item.currentBalance)}}</strong>,
                Tipo: {{data.item.bankAccountType.name}}
                {{data.item.agencyNumber ? '- Agência: ' + data.item.agencyNumber : ''}}
                {{data.item.agencyNumber ? '- Número: ' + data.item.accountNumber : ''}}
              </v-list-item-subtitle> -->
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.nameWithBank}}</v-list-item-title>
              
            </v-list-item-content>
          </template>

          <template v-slot:append-outer>
            <BankAccountNew
              :inlineAddButton="true"
              @entry-created="bankAccountCreated"
              modelNameSingular="Conta Bancária"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="4">
        <v-autocomplete
          v-model="entry.paymentConditionId"
          v-bind="getObject('paymentConditionId')"
          :label="'Condição de ' + typeText"
          :items="allPaymentConditions"
          item-value="id"
          item-text="description"
          @input="selectPaymentCondition(true)"
          :disabled="allPaymentConditions.length < 1 || readOnly"
          :loading="paymentConditionLoading"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="6" v-if="entry.paymentCondition && entry.paymentCondition.numberOfInstallments > 0">
        <DateField
          :inputData.sync="entry.initialDate"
          v-bind="getObject('initialDate')"
          label="Data da 1ª Parcela"
          @update:inputData="createInstallments"
          :hasTodayDate="true"
          :hasTodayButton="true"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-if="entry.paymentCondition && entry.paymentCondition.numberOfInstallments > 1"
          v-model="entry.installmentsIntervalId"
          v-bind="getObject('installmentsIntervalId')"
          :label="entry.paymentCondition.numberOfInstallments == 1 ? 'Intervalo da Parcela' : 'Intervalo das Parcelas'"
          :items="extraData.globalContext.allInstallmentsIntervals"
          item-value="id"
          item-text="description"
          @input="selectInstallmentsInterval"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.installmentsAttributes && entry.installmentsAttributes.length > 0 && entry.paymentCondition && entry.paymentCondition.numberOfInstallments > 0">
        <a class="title mb-1" @click="displayInstallments = !displayInstallments">{{displayInstallments ? 'Esconder Parcelas' : 'Mostrar Parcelas'}}</a>
        <InstallmentEditableIndex
          v-if="displayInstallments"
          :loading="loadingInstallments"
          :installments.sync="entry.installmentsAttributes"
          :paymentTotal="entry.value"
          class="mt-3"
          :key="installmentsKey"
          :readOnly="readOnly"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import InstallmentEditableIndex from "@models/installments/editableIndex.vue"
import moment from "moment";
import gql from 'graphql-tag'
import BankAccountNew from "@models/bank_accounts/new.vue"
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      bankAccountListLoading: false,
      bankAccountList: [],
      allPaymentConditions: [],
      renderComponent: true,
      displayInstallments: true,
      loadingInstallments: false,
      paymentConditionLoading: false,
      installmentsKey: 1,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    totals: Object,
    typeText: {
      type: String,
      default: "Pagamento"
    },
    modelType: {
      type: String,
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    DateField: DateField,
    MaskedTextField: MaskedTextField,
    InstallmentEditableIndex: InstallmentEditableIndex,
    BankAccountNew: BankAccountNew,
    BaseUtil: BaseUtil
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    if (this.entry.paymentMethod) {
      this.selectPaymentMethod(null);
    }

    // console.log("entryAttributs: ",   this.entryAttributes)
    //this.entry.numberOfInstallments = this.entry.numberOfInstallments ? this.entry.numberOfInstallments : 1;
    //this.entry.installmentsIntervalModel = this.entry.installmentsIntervalModel ? this.entry.installmentsIntervalModel.toString() : null;

    this.entryAttributes.initialDate.rules = [];
    this.entryAttributes.initialDate.rules.push(this.requiredRule);

    this.entryAttributes.value.rules = [];
    this.entryAttributes.value.rules.push(this.requiredRule);
    this.entryAttributes.value.rules.push(this.minRequiredRule);
    if (this.totals.limit) {
      var maxPayment = 0;
      var hintText = null;
      // console.log("this.entry.value", this.entry.value);
      if (this.entry.value) {
        maxPayment = this.totals.limit ? _.round(this.totals.limit - (this.totals.payments ? this.totals.payments : 0), 2) : this.entry.value;
        maxPayment += this.entry.value;
        hintText = "Valor total de: ";
      } else {
        this.entry.value = this.totals.limit ? _.round(this.totals.limit - (this.totals.payments ? this.totals.payments : 0), 2) : this.entry.value;
        maxPayment = this.entry.value;
        hintText = "Valor restante de: ";
      }
      maxPayment = _.round(maxPayment, 2);
      this.entryAttributes.value.rules.push(this.maxCurrencyRule(maxPayment));
      this.entryAttributes.value.hint = hintText + this.numberToCurrency(maxPayment);
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectPaymentMethod: function(newBankAccount=null) {
      // console.log("rodou selectPaymentMethod", newBankAccount);
      this.entry.paymentMethod = this.extraData.globalContext.allGlobalPaymentMethods.find(obj => obj.id == this.entry.paymentMethodId);
      // this.entry.bankAccountId = null;
      this.bankAccountListLoading = true;
      this.paymentConditionLoading = true;
      this.$apollo
        .query({
          query: ALL_BANK_ACCOUNTS_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            paymentMethodId: this.entry.paymentMethodId,
            paymentId: this.entry.id,
          }
        })
        .then(response => {
          // console.log("response.data", response.data);
          this.bankAccountList = response.data.accountContext.allBankAccountsNoInvestments;
          if (newBankAccount) {
            let result_find = this.bankAccountList.find(obj => obj.id == newBankAccount.id);
            if (result_find) {
              this.entry.bankAccountId = newBankAccount.id;
              this.entry.bankAccount = newBankAccount;
              this.selectBankAccount();
            } else {
              this.$refs.util.showErrorMessage("A conta bancária criada não permite a forma de pagamento selecionada, por isso não irá aparecer na lista de contas bancárias!");
            }
          } else if (this.entry.bankAccountId) {
            this.selectBankAccount();
          } else if (this.bankAccountList.length == 1) {
            this.entry.bankAccountId = this.bankAccountList[0].id;
            this.selectBankAccount();
          }

          this.allPaymentConditions = response.data.globalContext.allPaymentConditions;
          if (this.entry.paymentConditionId) {
            this.selectPaymentCondition(false);
          } else if (this.allPaymentConditions.length == 1) {
            this.entry.paymentConditionId =  this.allPaymentConditions[0].id;
            this.selectPaymentCondition(true);
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.bankAccountListLoading = this.paymentConditionLoading = false));
    },
    selectBankAccount: function() {
      this.entry.bankAccount = this.bankAccountList.find(obj => obj.id == this.entry.bankAccountId);
      // console.log("this.entry.bankAccount", this.entry.bankAccount);
      if (!this.entry.bankAccount) {
        this.entry.bankAccountId = null;
        console.log("this.entry.bankAccount and ID", this.entry.bankAccount, this.entry.bankAccountId);
        if (this.bankAccountList.length == 1) {
            this.entry.bankAccountId = this.bankAccountList[0].id;
            this.entry.bankAccount = this.bankAccountList[0];
        }
      }
    },
    selectPaymentCondition: function(createInstallments) {
      this.entry.paymentCondition = this.allPaymentConditions.find(obj => obj.id == this.entry.paymentConditionId);
      if (!this.entry.paymentCondition) {
        this.entry.paymentConditionId = null;
        if (this.allPaymentConditions.length == 1) {
          this.entry.paymentConditionId =  this.allPaymentConditions[0].id;
          this.entry.paymentCondition = this.allPaymentConditions[0];
          createInstallments = true;
        }
      }

      if (this.entry.paymentCondition && this.entry.paymentCondition.numberOfInstallments <= 1) {
        this.entry.installmentsIntervalId = null;
        this.entry.installmentsInterval = null;
      }

      if (!this.entry.installmentsIntervalId && this.entry.paymentCondition && this.entry.paymentCondition.numberOfInstallments > 1) {
        this.entry.installmentsInterval = this.extraData.globalContext.allInstallmentsIntervals.find(obj => obj.intervalInDays == 30);
        this.entry.installmentsIntervalId = this.entry.installmentsInterval.id;
      }

      if (createInstallments) {
        this.createInstallments();
      }

    },
    selectInstallmentsInterval: function() {
      this.entry.installmentsInterval = this.extraData.globalContext.allInstallmentsIntervals.find(obj => obj.id == this.entry.installmentsIntervalId);
      this.createInstallments();
    },
    clearFields: function() {
      this.forceRerender(this);
    },
    createInstallments: function() {
      // console.log("criar parcelas");
      this.destroyAllInstallments();
      if (this.entry.paymentCondition && ((this.entry.paymentCondition.numberOfInstallments > 0 && this.entry.initialDate) || this.entry.paymentCondition.numberOfInstallments == 0) && this.entry.value && (this.entry.paymentCondition.numberOfInstallments <= 1 || (this.entry.paymentCondition.numberOfInstallments > 1 && this.entry.installmentsInterval))) {
        // this.entry.installmentsInterval
        // console.log("criou parcelas", this.entry.paymentCondition.numberOfInstallments);
        var numDays;
        var numberOfInstallments = this.entry.paymentCondition.numberOfInstallments;
        if (numberOfInstallments <= 1) {
          numberOfInstallments = 1;
          numDays = 0
        } else {
          numDays = this.entry.installmentsInterval.intervalInDays;
        }
        if (numberOfInstallments > 0) {
          let first_installment_position = 0;
          this.loadingInstallments = true;
          for (var i = 1; i <= numberOfInstallments; i++) {
            let installmentValue = _.round((this.entry.value / numberOfInstallments), 2);
            let rawDueDate = this.entry.paymentCondition.numberOfInstallments > 0 ? moment(this.entry.initialDate) : moment()
            let installment = {
              code: i,
              value: installmentValue,
              originalValue: installmentValue,
              dueDate: rawDueDate.add(((i - 1) * numDays), 'days').toISOString().substr(0, 10)
            }
            let last_length = this.entry.installmentsAttributes.push(installment);
            if (i == 1) {
              first_installment_position = last_length - 1;
            }
          }
          if (_.round((this.entry.value / numberOfInstallments), 2) * numberOfInstallments != this.entry.value) {
            var diff = _.round(this.entry.value - (_.round((this.entry.value / numberOfInstallments), 2) * numberOfInstallments), 2);
            this.entry.installmentsAttributes[first_installment_position].originalValue = _.round(this.entry.installmentsAttributes[first_installment_position].originalValue + diff, 2);
          }
          this.loadingInstallments = false;
        }
      }
      this.installmentsKey++;
    },
    destroyAllInstallments: function() {
      let installment = this.entry.installmentsAttributes.length;
      while (installment--) {
        if (this.entry.installmentsAttributes[installment].id) {
          this.$set(this.entry.installmentsAttributes[installment], '_destroy', true);
        } else {
          this.entry.installmentsAttributes.splice(installment, 1);
        }
      }
      // for (var installment in this.entry.installmentsAttributes) {
      //   this.$set(this.entry.installmentsAttributes[installment], '_destroy', true);
      // }
    },
    bankAccountCreated: function(bankAccount) {
      this.selectPaymentMethod(bankAccount);
    },
  }
};
const ALL_BANK_ACCOUNTS_QUERY = gql `
  query ($paymentMethodId: ID!, $paymentId: ID) {
    accountContext {
      allBankAccountsNoInvestments(paymentMethodId: $paymentMethodId, paymentId: $paymentId) {
        id
        name
        nameWithBank
        currentBalance
        accountNumber
        agencyNumber
        bankAccountType {
          id
          name
        }
        bank {
          id
          name
          nameWithCode
        }
      }
    }
    globalContext {
      allPaymentConditions(paymentMethodId: $paymentMethodId) {
        id
        description
        numberOfInstallments
      }
    }
  }
`;
</script>

<style scoped></style>
